/**
 * MapCoordinateViewer – fixed bar at the bottom of a Leaflet map tracking the
 * cursor position, showing both DD:MM:SS.SSSS and decimal degree (DD.DDDD)
 * formats.
 *
 * Props:
 *   map – Leaflet map instance (L.Map) or null
 */
import React, { useState, useEffect } from 'react';
import { T } from '../assets/theme';

function toDMS(deg) {
    const sign = deg < 0 ? '-' : '';
    const abs = Math.abs(deg);
    const d = Math.floor(abs);
    const mFull = (abs - d) * 60;
    const m = Math.floor(mFull);
    const s = (mFull - m) * 60;
    return `${sign}${d}:${String(m).padStart(2, '0')}:${s.toFixed(4).padStart(7, '0')}`;
}

export default function MapCoordinateViewer({ map }) {
    const [pos, setPos] = useState(null);

    useEffect(() => {
        if (!map) return;
        const onMove = (e) => setPos(e.latlng);
        const onOut = () => setPos(null);
        map.on('mousemove', onMove);
        map.on('mouseout', onOut);
        return () => {
            map.off('mousemove', onMove);
            map.off('mouseout', onOut);
        };
    }, [map]);

    return (
        <div style={{
            position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 500,
            background: 'rgba(6,14,26,0.88)', borderTop: `1px solid ${T.border}`,
            padding: '4px 12px', display: 'flex', gap: 24, alignItems: 'center',
            fontSize: 11, fontFamily: 'monospace', color: T.muted,
            backdropFilter: 'blur(8px)', pointerEvents: 'none', whiteSpace: 'nowrap',
        }}>
            {pos ? (
                <>
                    <span>DMS: <b style={{ color: T.white }}>{toDMS(pos.lat)}</b>, <b style={{ color: T.white }}>{toDMS(pos.lng)}</b></span>
                    <span>DD: <b style={{ color: T.white }}>{pos.lat.toFixed(4)}</b>, <b style={{ color: T.white }}>{pos.lng.toFixed(4)}</b></span>
                </>
            ) : (
                <span>Move cursor over map to see coordinates</span>
            )}
        </div>
    );
}
